import React from "react";
import {
    Box, IconButton, Stack, TextField, Tooltip, Typography,
} from "@mui/material";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import RefreshRoundedIcon            from "@mui/icons-material/RefreshRounded";
import "dayjs/locale/ko";
import { ADMIN_TYPE_FILTERS, STATUS_FILTERS } from "./approvalConstants";
import TablePaginator, { TableSizeSelect, DEFAULT_PAGE_SIZE } from "../../component/common/TablePaginator";
import LoadingDots from "../../component/common/LoadingDots";
import ComboBox from "../../component/common/ComboBox";
import ApprovalTable from "./ApprovalTable";

/* ── ApprovalAdminPanel — 전폭 필터 + 표 ─── */
export default function ApprovalAdminPanel({
    adminApprovals,
    totalCount,
    adminLoading,
    adminTypeFilter,
    setAdminTypeFilter,
    adminStatusFilter,
    setAdminStatusFilter,
    adminSubmitterFilter,
    setAdminSubmitterFilter,
    adminApproverFilter,
    setAdminApproverFilter,
    onExit,
    onRefresh,
    selected,
    onSelect,
    page          = 1,
    pageSize      = DEFAULT_PAGE_SIZE,
    totalPages    = 1,
    totalElements = 0,
    onPageChange,
    onPageSizeChange,
}) {
    const searchSx = { flex: 1, minWidth: 150 };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* 헤더 */}
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Box onClick={onExit} sx={{ fontSize: 12, color: "#2563eb", cursor: "pointer", fontWeight: 600 }}>
                        ← 일반 모드
                    </Box>
                    <AdminPanelSettingsRoundedIcon sx={{ fontSize: 18, color: "#2563eb" }} />
                    <Typography sx={{ fontWeight: 800, fontSize: 18, color: "#0f172a" }}>전체 결재 현황 (관리자)</Typography>
                </Stack>
                <Tooltip title="새로고침">
                    <IconButton size="small" onClick={onRefresh} disabled={adminLoading}>
                        <RefreshRoundedIcon sx={{ fontSize: 18, color: "#2563eb" }} />
                    </IconButton>
                </Tooltip>
            </Stack>

            {/* 드롭다운 필터 바 (한 줄): 상태 · 결재유형 · 기안자 · 결재자 */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Box sx={{ width: 104, flexShrink: 0 }}>
                        <ComboBox clearable={false} placeholder="상태"
                            options={STATUS_FILTERS.map((f) => ({ value: f.value, label: f.label }))}
                            value={adminStatusFilter}
                            onChange={(v) => setAdminStatusFilter(v)} />
                    </Box>

                    <Box sx={{ width: 116, flexShrink: 0 }}>
                        <ComboBox clearable={false} placeholder="결재유형"
                            options={ADMIN_TYPE_FILTERS.map((f) => ({ value: f.value, label: f.label }))}
                            value={adminTypeFilter}
                            onChange={(v) => setAdminTypeFilter(v)} />
                    </Box>

                    <TextField size="small" value={adminSubmitterFilter}
                        onChange={(e) => setAdminSubmitterFilter(e.target.value)}
                        placeholder="기안자 이름/부서 검색" sx={searchSx} />
                    <TextField size="small" value={adminApproverFilter}
                        onChange={(e) => setAdminApproverFilter(e.target.value)}
                        placeholder="결재자 이름/부서 검색" sx={searchSx} />
                </Stack>

                <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>
                    표시 {adminApprovals.length}건 / 전체 {totalCount ?? adminApprovals.length}건
                </Typography>
                {/* N개씩 보기 — 표 우측 상단 고정(공용 컨트롤) */}
                <TableSizeSelect value={pageSize} onChange={onPageSizeChange} />
            </Box>

            {/* 표 + 페이지네이션 */}
            <Box>
                {adminLoading
                    ? <LoadingDots />
                    : <ApprovalTable rows={adminApprovals} selected={selected} onSelect={onSelect} emptyText="결재 없음" />}
                <TablePaginator
                    totalPages={totalPages}
                    total={totalElements}
                    pageSize={pageSize}
                    page={page}
                    onPageChange={onPageChange}
                />
            </Box>
        </Box>
    );
}
